import { useState, useEffect } from "react";
import React from "react";
import {
  machineProfile,
  part,
  workOrder,
  vendor,
  customer,
  team,
  user,
  asset,
  workOrderCategory,
  workOrderRequestComment,
  quotation,
} from "../../api";
import { toast } from "react-toastify";
import {
  dateFormat,
  generateLocationToArray,
  getFileUrl,
  getRequestStatusColor,
  getStatusColor,
  printLocation,
  renderImage,
} from "../../utils/helper";
import { QRCode } from "react-qrcode-logo";
import { useNavigate, useParams } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { useDashboardContext } from "../../contexts/NewDashboardContext";
import LoadingIndicator from "../../components/LoadingIndicator";
import NormalInput from "../../components/form/HorizontalNormalInput";
import NormalSelect from "../../components/form/HorizontalNormalSelect";
import NormalTextArea from "../../components/form/HorizontalNormalTextarea";
import { DatepickerOpt } from "../../components/form/DatepickerOpt";
import DateTime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import { Card, CardBody, CardHeader } from "../../components/card/card";
import { MachineElement } from "../../components/MachineElement";
import ImageViewer from "../../components/ImageViewer";
import { format } from "date-fns";
import { data } from "jquery";
import Dropdown from "react-bootstrap/Dropdown";
import { TaskAction } from "../../components/TaskAction";
import { InventorySelector } from "../../components/InventorySelector";
import { CardFooter, Modal } from "react-bootstrap";
import AddQuotation from "../quotation/add";
import ConfirmationDlg from "../../components/ConfirmationDlg";
import { PermissionChecker } from "../../components/PermissionChecker";

function WorkOrderDetailRequest() {
  const { id } = useParams();
  const { authUser, getLocationName } = useAuth();
  const editMode = !!id;
  const [status, setStatus] = useState("");
  const [openApproveConfirmation, setOpenApproveConfirmation] = useState(false);
  const [openDeclineConfirmation, setOpenDeclineConfirmation] = useState(false);
  const [comments, setComments] = useState([]);
  const [commentText, setCommentText] = useState("");
  const [attachments, setAttachments] = useState([]);
  const [openQuotationForm, setOpenQuotationForm] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingComment, setIsLoadingComment] = useState(false);
  const [assignType, setAssignType] = useState("individual");
  const [openPDF, setOpenPDF] = useState(false);
  const [email, setEmail] = useState("");
  const [selectedFile, setSelectedFile] = useState("");
  const [locations, setLocations] = useState([]);
  const [dataToSend, setDataToSend] = useState({
    asset_id: "",
    start_date: "",
    due_date: "",
    status: "",
    description: "",
    title: "",
    recurring_wo: "",
    priority: "medium",
    assigned_to: "",
    team_id: "",
    vendor_id: "",
    category_id: "",
    request_tasks: [],
    work_order_tasks: [],
    inventories: [],
  });
  const navigate = useNavigate();
  function backToList() {
    navigate(-1);
  }

  async function getMasterData() {
    setIsLoading(true);
    try {
      if (editMode) {
        await getRecord();
        await getComments();
      }
    } catch (err) {
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    getMasterData();
  }, [id]);

  async function getComments() {
    const result = await workOrderRequestComment.list({
      work_order_id: id,
    });

    if (result.ok) {
      const body = await result.json();
      setComments(body.data);
    }
  }

  async function getRecord() {
    const result = await workOrder.getOne(id);

    if (result.ok) {
      const body = await result.json();
      let data = body.data;

      const defaultValue = {
        asset_id: data.asset_id,
        start_date: format(new Date(data.start_date), "yyyy-MM-dd"),
        due_date: format(new Date(data.due_date), "yyyy-MM-dd"),
        created_at: format(new Date(data.created_at), "yyyy-MM-dd"),
        status: data.status,
        description: data.description,
        title: data.title,
        recurring_wo: data.recurring_wo,
        priority: data.priority,
        assigned_to: data.assigned_to,
        team_id: data.team_id || "",
        vendor_id: data.vendor_id,
        category: data.category?.name,
        vendor: data.vendor?.vendor_name,
        assigned: data.team_id
          ? data.team?.team_name
          : data.assigned_to_user?.firstname,
        assignType: data.team_id ? "Team" : "Individual",
        asset: data.asset?.asset_name,
        request_tasks: data.tasks.filter((t) => t.is_request) || [],
        work_order_tasks: data.tasks.filter((t) => !t.is_request) || [],
        inventories: data.inventories || [],
        created_by: data.created_by_user?.firstname ?? data?.requested_by,
        request_status: data.request_status,
        action_taken_by_user: data.action_taken_by_user,
        action_taken_date: data.action_taken_date
          ? format(new Date(data.action_taken_date), "yyyy-MM-dd")
          : "-",
        quotations: data.quotations,
        request_document: data.request_document,
        number: data.number,
        problem_type_note: data.problem_type_note,
      };

      if(data.problem_type) {
        const problemTypeSeq = [];
        function generateProblemType(problemType) {
          problemTypeSeq.push(problemType.problem_type_name);
          if (problemType.parent_problem_type) {
            generateProblemType(problemType.parent_problem_type);
          }
        }

        generateProblemType(data.problem_type);

        defaultValue.problem_type = problemTypeSeq.reverse().join(" - ");
      }


      if(data.asset?.location) {
        const locationName = [];
        function generateLocation(location) {
          locationName.push(location.location_name);
          if (location.parent_location) {
            generateLocation(location.parent_location);
          }
        }

        generateLocation(data.asset.location);
        setLocations(locationName.reverse());
      }else if(data.location) {
        const locationName = [];
        function generateLocation(location) {
          locationName.push(location.location_name);
          if (location.parent_location) {
            generateLocation(location.parent_location);
          }
        }
        generateLocation(data.location);
        setLocations(locationName.reverse());
      }


      if (defaultValue.request_tasks.length > 0) {

        defaultValue.request_tasks.forEach((task) => {
          if (task.task_photo)
            task.url_full = renderImage(
              `machine/attachment/${task.task_photo}`
            );
        });
      }

      if (defaultValue.work_order_tasks.length > 0) {
        defaultValue.work_order_tasks.forEach((task) => {
          if (task.task_photo)
            task.url_full = renderImage(
              `machine/attachment/${task.task_photo}`
            );
        });
      }



      setStatus(data.request_status);
      setDataToSend(defaultValue);
      if (data.attachments) {
        // check if data.attachments is an object
        if (typeof data.attachments !== "object") {
          console.error("attachments is not an object");
          return;
        }
        const att = [];
        if (data.attachments)
          Object.keys(data.attachments).forEach((key) => {
            if (data.attachments[key]) {
              const name = key.split("_")[3];
              const type = key.split("_")[2];
              const isRequest = key.split("_")[0] !== "workoder";
              const url = renderImage(
                `machine/attachment/${data.attachments[key]}`
              );
              const attachment = {
                name: name,
                type,
                url,
                value: data.attachments[key],
              };
              att.push(attachment);
              // if (!isRequest) {
              //
              // }else{
              //   attReq.push(attachment)
              // }
            }
          });
        setAttachments(att);
      }
    }
  }

  const handleChangeStatus = async (v) => {
    try {
      let result;

      result = await workOrder.updateRequestStatus(
        id,
        { status: v },
        selectedFile
      );

      if (result.ok) {
        toast.success("Status updated");
        setOpenApproveConfirmation(false);
        setOpenDeclineConfirmation(false);
        getMasterData();
        setSelectedFile("");
      } else {
        toast.error("Status failed to update");
      }
    } catch (e) {
      toast.error(e.message);
    }
  };

  const handleSendPdf = async () => {
    try {
      setIsLoading(true);
      const result = await quotation.sendPdf(dataToSend.quotations[0].id, {
        email: email,
      });
      if (result.ok) {
        setOpenPDF(false);
        setEmail("");
        toast.success("PDF File has been sent to the email");
      }
    } catch (e) {
      console.log(e);
      toast.error("Something went wrong, please try again");
    } finally {
      setIsLoading(false);
    }
  };

  const handleAfterSubmitQuotation = () => {
    setOpenQuotationForm(false);
    getRecord();
  };

  const handleSendComment = async () => {
    if (!commentText) {
      return;
    }
    try {
      let result;
      setIsLoadingComment(true);

      result = await workOrderRequestComment.create({
        work_order_id: id,
        comment: commentText,
      });

      if (result.ok) {
        getComments();
        setCommentText("");
      } else {
        toast.error("Something went wrong, please try again");
      }
    } catch (e) {
      toast.error(e.message);
    } finally {
      setIsLoadingComment(false);
    }
  };

  const handleDeleteComment = async (commentId) => {
    try {
      let result;
      setIsLoadingComment(true);

      result = await workOrderRequestComment.delete(commentId);

      if (result.ok) {
        getComments();
      } else {
        toast.error("Something went wrong, please try again");
      }
    } catch (e) {
      toast.error(e.message);
    } finally {
      setIsLoadingComment(false);
    }
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setSelectedFile(file);
  };

  return (
    <Card>
      <LoadingIndicator open={isLoading} />
      <CardHeader>Request Information</CardHeader>

      <CardBody>
        <div className="row g-3">
          <div className="col-md-6">
            <div className="mb-3">
              <label htmlFor="workOrderTitle" className="form-label">
                Request Title
              </label>
              <input
                disabled
                value={dataToSend["title"]}
                className="form-control"
                required
              />
            </div>

            <div className="mb-3">
                <label htmlFor="workOrderNumber" className="form-label">
                    Request Number
                </label>
                <input
                  disabled
                  value={`RQ#${dataToSend["number"]}`}
                  className="form-control"
                  required
                />
              </div>

            <div className="mb-3">
              <label htmlFor="startDate" className="form-label">
                Created Date
              </label>
              <input
                disabled
                value={dataToSend["created_at"]}
                className="form-control"
                required
              />
            </div>

            <div className="mb-3">
              <label htmlFor="startDate" className="form-label">
                Start Date
              </label>
              <input
                disabled
                value={dataToSend["start_date"]}
                className="form-control"
                required
              />
            </div>

            <div className="mb-3">
              <label htmlFor="dueDate" className="form-label">
                Due Date
              </label>
              <input
                disabled
                value={dataToSend["due_date"]}
                className="form-control"
                required
              />
            </div>

            <div className="mb-3">
              <label htmlFor="recurringWO" className="form-label">
                Recurring WO
              </label>
              <input
                disabled
                value={dataToSend["recurring_wo"] || "No"}
                className="form-control"
                required
              />
            </div>
            <div className="mb-3">
              <label htmlFor="description" className="form-label">
                Description
              </label>
              <input
                disabled
                value={dataToSend["description"]}
                className="form-control"
                required
              />
            </div>

            {locations.map((l, index) => {
                return (
                  <div key={index} className="mb-3">
                <label htmlFor="location" className="form-label">
                  {getLocationName(index)}
                </label>
                <input
                  disabled
                  value={l}
                  className="form-control"

                />
              </div>
                );
            })}


            <div className="mb-3">
              <label htmlFor="asset" className="form-label">
                Asset
              </label>
              <input
                disabled
                value={dataToSend.asset}
                className="form-control"
                required
              />
            </div>

            <div className="mb-3">
              <label htmlFor="priority" className="form-label">
                Priority
              </label>
              <input
                disabled
                value={dataToSend["priority"]}
                className="form-control"
                required
              />
            </div>
            <div className="mb-3">
              <label htmlFor="priority" className="form-label">
                Category
              </label>
              <input
                disabled
                value={dataToSend.category}
                className="form-control"
                required
              />
            </div>

            <div className="mb-3">
              <label htmlFor="assignee" className="form-label">
                Assignee Type
              </label>
              <input
                disabled
                value={dataToSend.assignType}
                className="form-control"
                required
              />
            </div>

            <div className="mb-3">
              <label htmlFor="assignee" className="form-label">
                Assigned to
              </label>
              <input
                disabled
                value={dataToSend.assigned}
                className="form-control"
                required
              />
            </div>
          </div>

          <div className="col-md-6">

          <div className="mb-3">
                <label htmlFor="problem_type_id" className="form-label">
                  Service Group / Problem Type
                </label>
                <input
                  disabled
                  value={dataToSend.problem_type}
                  className="form-control"
                  required
                />
              </div>

            {dataToSend.problem_type_note && ( <div className="mb-3">
                <label htmlFor="problem_type_note" className="form-label">
                  Problem Type Note
                </label>
                <input
                  disabled
                  value={dataToSend.problem_type_note}
                  className="form-control"
                />
              </div>)}


            {dataToSend.request_status != "Pending" && (
              <Card style={{ marginTop: "10px" }}>
                <LoadingIndicator open={isLoading} />
                <CardHeader>Status Information</CardHeader>
                <CardBody>
                  <div className="mb-3">
                    <label htmlFor="assignee" className="form-label">
                      Request Status
                    </label>
                    <input
                      disabled
                      value={status}
                      className="form-control"
                      required
                    />
                  </div>

                  <div className="mb-3">
                    <label htmlFor="assignee" className="form-label">
                      {status} By
                    </label>
                    <input
                      disabled
                      value={dataToSend.action_taken_by_user?.firstname}
                      className="form-control"
                      required
                    />
                  </div>

                  <div className="mb-3">
                    <label htmlFor="assignee" className="form-label">
                      {status} At
                    </label>
                    <input
                      disabled
                      value={dataToSend.action_taken_date}
                      className="form-control"
                      required
                    />
                  </div>
                </CardBody>
              </Card>
            )}

            <Card style={{ marginTop: "10px", marginBottom: "10px" }}>
              <LoadingIndicator open={isLoading} />
              <CardHeader>Requester Information</CardHeader>
              <CardBody>
                <div className="mb-3">
                  <label htmlFor="assignee" className="form-label">
                    Submitted by
                  </label>
                  <input
                    disabled
                    value={dataToSend.created_by}
                    className="form-control"
                    required
                  />
                </div>

                <div className="mb-3">
                  <label htmlFor="assignee" className="form-label">
                    Created at
                  </label>
                  <input
                    disabled
                    value={dataToSend.created_at}
                    className="form-control"
                    required
                  />
                </div>
              </CardBody>
            </Card>

            <Card className="mb-4">
              <CardHeader>Photo / File</CardHeader>
              <CardBody>
                <div class="form-group">
                  {!dataToSend.request_document && (
                    <p className="mt-2">- No File Uploaded -</p>
                  )}

                  {dataToSend.request_document && (
                    <p className="mt-2">
                      <a
                        href={getFileUrl(dataToSend.request_document.photo)}
                        target="_blank"
                      >
                        Here
                      </a>{" "}
                    </p>
                  )}
                </div>
              </CardBody>
            </Card>

            <Card style={{ marginTop: "10px", marginBottom: "10px" }}>
              <LoadingIndicator open={isLoading} />
              <CardHeader>Updates</CardHeader>
              <CardBody>
                {comments.map((c, i) => {
                  return (
                    <div
                      className="mb-3"
                      key={i}
                      style={{
                        borderBottom: "1px solid #b6b6b6",
                        paddingBottom: "5px",
                      }}
                    >
                      <div className="d-flex">
                        <div style={{ color: "#b6b6b6", fontSize: "12px" }}>
                          {c.created_by_user?.firstname} |{" "}
                          {format(new Date(c.created_at), "yyyy-MM-dd hh:mm")}
                        </div>

                        <div style={{ marginLeft: "auto" }}>
                          {authUser?.username == c.created_by && (
                            <button
                              disabled={isLoadingComment}
                              onClick={() => handleDeleteComment(c.id)}
                              type="button"
                              style={{ marginRight: "10px" }}
                              className="btn btn-sm btn-outline-danger"
                            >
                              <i className="fa fa-trash"></i>
                            </button>
                          )}
                        </div>
                      </div>

                      <div style={{ fontSize: "13px" }}>{c.comment}</div>
                    </div>
                  );
                })}

                {comments.length == 0 && (
                  <div style={{ marginBottom: "10px" }}>- No updates -</div>
                )}

                <div className="mb-3">
                  <textarea
                    value={commentText}
                    className="form-control"
                    onChange={(e) => setCommentText(e.target.value)}
                  ></textarea>

                  <button
                    disabled={isLoadingComment}
                    onClick={handleSendComment}
                    style={{ marginLeft: "auto" }}
                    className="btn btn-outline-theme mt-2"
                  >
                    Add Comment
                  </button>
                </div>
              </CardBody>
            </Card>
          </div>
        </div>
        {attachments.length > 0 && (
          <div className="mb-3">
            <Card>
              <CardHeader className="d-flex align-items-center bg-inverse bg-opacity-10 fw-400">
                Attachments
              </CardHeader>
              <CardBody>
                <div class="row">
                  {attachments.map((attachment, index) => (
                    <div key={index} className={"col-md-4 position-relative"}>
                      {attachment.type === "image" && (
                        <ImageViewer
                          staticImage={attachment.url}
                          className={"img-fluid w-100"}
                          alt=""
                        />
                      )}
                      {attachment.type === "video" && (
                        <video
                          src={attachment.url}
                          className={"img-fluid w-100"}
                          width={"100%"}
                          controls
                        />
                      )}
                      {attachment.type === "pdf" && (
                        <iframe
                          src={attachment.url}
                          className={" w-100"}
                          width={"100%"}
                          height={"350px"}
                        />
                      )}
                      {attachment.type === "other" && (
                        <a
                          href={attachment.url}
                          target={"_blank"}
                          rel="noreferrer"
                          style={{
                            height: "200px",
                            paddingTop: "95px",
                            display: "block",
                          }}
                          className={
                            "border-theme border-1 border w-100 text-center"
                          }
                        >
                          Download the File
                        </a>
                      )}

                      <div className="my-2">
                        <input
                          type="text"
                          className={"form-control"}
                          value={attachment.name}
                          readOnly
                          disabled
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </CardBody>
            </Card>
          </div>
        )}

        <div className="mt-2">
          <TaskAction title="Request Task List" onChange={() => {}} value={dataToSend["request_tasks"]} />
        </div>

        <div className="mt-2">
          <TaskAction title="Work Order Task List" onChange={() => { }} value={dataToSend["work_order_tasks"]} />
        </div>

        {/* <div className="mt-2">
          <InventorySelector readOnly onChange={() => { }} value={dataToSend['inventories']}/>
        </div> */}

        <Card style={{ marginTop: "10px" }}>
          <LoadingIndicator open={isLoading} />
          <CardHeader>More Information</CardHeader>
          <CardBody>
            <label htmlFor="assignee" className="form-label">
              Vendor
            </label>
            <input
              disabled
              value={dataToSend.vendor}
              className="form-control"
              required
            />
          </CardBody>
        </Card>

        {dataToSend.request_status == "Pending" && (
          <div className="mt-4 flex">
            <PermissionChecker permissions={["approve request"]} hideIfNotAllowed>
            <button
              className="btn btn-outline-theme btn-lg me-2"
              onClick={() => setOpenApproveConfirmation(true)}
            >
              APPROVE
              </button>
              </PermissionChecker>
            <PermissionChecker permissions={["decline request"]} hideIfNotAllowed>
            <button
              className="btn btn-outline-danger btn-lg me-2"
              onClick={() => setOpenDeclineConfirmation(true)}
            >
              DECLINE
              </button>
              </PermissionChecker>
            

            <button
              className="btn btn-outline-warning btn-lg me-2"
              onClick={() => navigate("/request/edit/" + id)}
            >
              EDIT
            </button>

            {dataToSend.quotations.length == 0 && (
              <button
                className="btn btn-outline-primary btn-lg"
                onClick={() => setOpenQuotationForm(true)}
              >
                CREATE QUOTATION
              </button>
            )}

            {dataToSend.quotations.length > 0 && (
              <>
                <button
                  className="btn btn-outline-primary btn-lg"
                  onClick={() => setOpenPDF(true)}
                >
                  GENERATE QUOTATION
                </button>
                <ConfirmationDlg
                  onSubmit={handleSendPdf}
                  title={"Email Quotation"}
                  type="submit"
                  open={openPDF}
                  onClose={() => setOpenPDF(false)}
                >
                  <NormalInput
                    onchange={(e) => setEmail(e.target.value)}
                    value={email}
                    label={"Recipient"}
                    helperText={"Please add email"}
                  />
                </ConfirmationDlg>
              </>
            )}
          </div>
        )}

        <Modal
          show={openQuotationForm}
          size={"xl"}
          onHide={() => setOpenQuotationForm(false)}
          onBackdropClick={() => setOpenQuotationForm(false)}
          centered
        >
          {id && (
            <AddQuotation
              work_order_id={id}
              afterSubmitCallback={handleAfterSubmitQuotation}
            />
          )}
        </Modal>

        <Modal
          show={openApproveConfirmation}
          onHide={() => setOpenApproveConfirmation(false)}
          centered
        >
          <Modal.Body className="p-0">
            <Card>
              <CardHeader className="p-3">
                <button
                  className="btn"
                  style={{
                    position: "absolute",
                    fontSize: 8,
                    textTransform: "uppercase",
                    right: 0,
                    top: "0",
                    bottom: "0",
                    marginTop: "auto",
                    marginBottom: "auto",
                    textDecoration: "underline",
                    minWidth: "30px",
                  }}
                  onClick={() => setOpenApproveConfirmation(false)}
                >
                  CLOSE
                </button>
              </CardHeader>
              <CardBody>
                Are you sure want to approve this request?
                <Card style={{ marginTop: "10px" }}>
                  <CardHeader>Upload Photo / File</CardHeader>
                  <CardBody>
                    <div class="form-group">
                      <input
                        type="file"
                        onChange={handleFileChange}
                        class="form-control"
                      />
                    </div>
                  </CardBody>
                </Card>
              </CardBody>
              <CardFooter>
                <div
                  style={{
                    textAlign: "center",
                    display: "flex",
                    justifyContent: "flex-end",
                    padding: "10px 0",
                  }}
                >
                  <button
                    className="btn btn-outline-theme me-2"
                    onClick={() => handleChangeStatus("Approved")}
                  >
                    Approve
                  </button>
                  <button
                    className="btn btn-outline-warning me-2"
                    onClick={() => navigate("/request/edit/" + id)}
                  >
                    Edit
                  </button>
                </div>
              </CardFooter>
            </Card>
          </Modal.Body>
        </Modal>

        <Modal
          show={openDeclineConfirmation}
          onHide={() => setOpenDeclineConfirmation(false)}
          centered
        >
          <Modal.Body className="p-0">
            <Card>
              <CardHeader className="p-3">
                <button
                  className="btn"
                  style={{
                    position: "absolute",
                    fontSize: 8,
                    textTransform: "uppercase",
                    right: 0,
                    top: "0",
                    bottom: "0",
                    marginTop: "auto",
                    marginBottom: "auto",
                    textDecoration: "underline",
                    minWidth: "30px",
                  }}
                  onClick={() => setOpenDeclineConfirmation(false)}
                >
                  CLOSE
                </button>
              </CardHeader>
              <CardBody>Are you sure want to decline this request? </CardBody>
              <CardFooter>
                <div
                  style={{
                    textAlign: "center",
                    display: "flex",
                    justifyContent: "flex-end",
                    padding: "10px 0",
                  }}
                >
                  <button
                    className="btn btn-outline-danger me-2"
                    onClick={() => handleChangeStatus("Declined")}
                  >
                    Decline
                  </button>
                </div>
              </CardFooter>
            </Card>
          </Modal.Body>
        </Modal>
      </CardBody>
    </Card>
  );
}

export default WorkOrderDetailRequest;
